"use strict";

import { MarketBuyItem } from 'api/tradeAPICall';
import { cachedBalance } from 'api/walletAPICall';
import ApplicationEvents from 'components/applicationEvents';
import { ViewAppIdIcon, ViewItemIconic } from 'components/commonAssets';
import { spawnDialogWindow } from 'components/dialogHolder';
import ViewItemBuyEditor from 'components/itemBuyEditor';
import { ViewItemMarketDepthOwnWarning } from 'components/itemMarketDepth';
import { defineSimpleTerm, _I_ } from 'components/locs';
import { spawnOnBuyReserveFailDialog } from 'components/messageBoxes';
import ViewPriceHistoryGraph from 'components/priceHistoryGraph';
import { CloseButton } from 'generics/buttons';
import { dataBound } from 'generics/dataBound';
import { IconFontAwesome } from 'generics/icons';
import React from 'react';
import ReactGA from 'react-ga';

class ConfirmBuyDialogBody extends React.Component  {
  constructor(props)  {
    super(props);

    this.processBuyOrder = () =>  this.placeOrder();
  }

  componentDidMount()  {
    const {  classInfo, appid  } = this.props;
    ReactGA.pageview('item/' + appid + '/' + encodeURI(classInfo.market_hash_name) + '/buy');
  }

  placeOrder()  {
    const  {
        isValid, amount, price, agree
      }  =  this.buyEditor.getResult();

    if ( (!isValid) || (!agree) )
      return;

    const {  hash_name,  appid,  classInfo  } = this.props;

    LogStream("VIEWTRADEDIALOG").info( "placeOrder", {  appid, amount, price, agree  } );
    MarketBuyItem(
        appid, hash_name, amount, price, agree
      ).then( ( resp ) =>  {
        LogStream("VIEWTRADEDIALOG").info( "buy order placed -> ", JSON.stringify(resp,null,"  ") );

        ReactGA.event({
          category: 'Order',
          action: 'buy'
        });

        ApplicationEvents.emit_async( "EventLog.append", {
                  "type":"log",
                  "caption": "Trade (BUY) Item",
                  "message": "Order issued successfully, please check your orders page later",
                  "details": { "response":resp,
                               "marketHashName":hash_name,
                               amount,
                               price,
                               "appId": appid     }
                });

        ApplicationEvents.emit_async("market.updateInventory");
        ApplicationEvents.emit_async("market.ordersUpdate");

      }).catch( ( reason ) =>  {
        if (  (((reason||{}).details||{}).response||{}).error == "SETUNOWNED_ACCEPT_FAIL"  )  {
          LogStream("VIEWTRADEDIALOG").error( "placeOrder - Failed (", reason, ")" );
          spawnOnBuyReserveFailDialog( appid, hash_name, classInfo, amount, price );
          ApplicationEvents.emit_async("market.updateInventory");
          ApplicationEvents.emit_async("market.ordersUpdate");

        }  else
          return Promise.reject( reason );
      }).catch( ( reason ) =>  {
            reason = Object.assign( {}, reason,
                                    {
                                      "caption":"Trade (BUY) Item Error",
                                      "message": ("Failed to buy item:\n"+reason.message)
                                    });

        LogStream("VIEWTRADEDIALOG").error( "placeOrder - Failed (", reason, ")" );
        ApplicationEvents.emit_async( "EventLog.append", reason );
        ApplicationEvents.emit_async("market.updateInventory");
        ApplicationEvents.emit_async("market.ordersUpdate");
      });

    ViewBuyProcessingDialog.spawnProcessingModal( appid, hash_name );
    this.props.removeModal(); // close self
  }


  render()  {
    return (
          <div className="panel-body">
            <div className="view-confirm-dialog-asset-title">{this.props.classInfo.name}</div>
            <div className="view-confirm-dialog-summary">
              <ViewItemIconic classInfo={this.props.classInfo} />
              <div>
                <ViewAppIdIcon appId={this.props.appid} compact />
                <ViewItemMarketDepthOwnWarning  type="sell"  haveOwnOrders={this.props.haveOwnOrders}  />
              </div>
              <ViewItemBuyEditor
                    initialPrice={this.props.initialPrice}
                    processBuyOrder={this.processBuyOrder}
                    balance={this.props.balance}
                    ref={ (buyEditor) => this.buyEditor = buyEditor }
                  />

            </div>
            <ViewPriceHistoryGraph
                    market_name={this.props.hash_name}
                    appid={this.props.appid}
                  />

          </div>
      );
  }
}


const Bound_ConfirmBuyDialogBody = dataBound(ConfirmBuyDialogBody, {
  "balance":cachedBalance
});


class ViewConfirmBuyDialog extends React.Component  {
  constructor(props)  {
    super(props);
  }


  onBackdropTouch()  {
    this.props.removeModal();
  }


  render()  {
    return (
        <div className="panel panel-success panel-sm view-confirm-buy-dialog">
          <div className="panel-heading">
            {_I_("ConfirmBuyDialog.title")}
            <CloseButton onClick={this.props.removeModal} />
          </div>

          <Bound_ConfirmBuyDialogBody  {...this.props} />
        </div>
      );
  }
}


class ViewBuyProcessingDialog extends React.Component  {
  constructor(props)  {
    super(props);

    this.refreshCurrentAsset = this.refreshCurrentAsset.bind(this);
  }


  static spawnProcessingModal( appId, hashName )  {
    spawnDialogWindow(ViewBuyProcessingDialog,  {
        appId,  hashName
      });
  }


  onBackdropTouch()  {
    // this.props.removeModal();
  }


  componentDidMount()  {
    ApplicationEvents.on("market.inventoryUpdateCompleted", this.refreshCurrentAsset );
  }


  componentWillUnmount()  {
    ApplicationEvents.off("market.inventoryUpdateCompleted", this.refreshCurrentAsset );
  }


  refreshCurrentAsset()  {
    const { hashName, appId } = this.props;

    ApplicationEvents.emit_async( "market.setCurrentAssetByHash", appId, hashName );
    this.props.removeModal();
  }


  render()  {
    return (
        <div className="panel panel-info panel-sm view-is-processing-dialog">
          <div className="panel-heading">
            {_I_("BuyProcessingDialog.title")}
          </div>

          <div className="panel-body">
            <div className="text-center">
              <IconFontAwesome type="spinner" size="3x" pulse fixedWidth />&nbsp;
            </div>
            <div className="text-center">
              <b>{_I_("BuyProcessingDialog.pleaseWait")}</b>
            </div>
          </div>
        </div>
    );
  }

}


export default function spawnConfirmDialogModal( initialPrice,  appid,  hash_name, classInfo, haveOwnOrders )  {
  spawnDialogWindow(ViewConfirmBuyDialog,  {
      initialPrice,  appid,  hash_name,  classInfo,  haveOwnOrders,
    });
}


defineSimpleTerm( "ConfirmBuyDialog.title",  "Place buy order",       {
    "ru_RU": "Покупка",
    "cs_CZ": "Place buy order",
    "fr_FR": "Valider votre commande",
    "de_DE": "Kaufbestellung platzieren",
    "it_IT": "Piazza un ordine d'acquisto",
    "ko_KR": "구매 요청",
    "pl_PL": "Umieść polecenie kupna",
    "pt_PT": "Place buy order",
    "es_ES": "Realizar pedido de compra",
    "zh_CN": "下达购买订单",
    "zh_TW": "下達購買訂單"
} );


defineSimpleTerm( "BuyProcessingDialog.title",  "Processing...",       {
    "ru_RU": "В процессе...",
    "cs_CZ": "Processing...",
    "fr_FR": "En cours...",
    "de_DE": "Bearbeiten...",
    "it_IT": "In processo...",
    "ko_KR": "진행중...",
    "pl_PL": "Przetwarzanie...",
    "pt_PT": "Processing...",
    "es_ES": "Procesando...",
    "zh_CN": "处理中…",
    "zh_TW": "處理中…"
} );


defineSimpleTerm( "BuyProcessingDialog.pleaseWait",  "Processing, please wait",       {
    "ru_RU": "Выполняется, пожалуйста подождите",
    "cs_CZ": "Processing, please wait",
    "fr_FR": "En cours, veuillez patienter",
    "de_DE": "Bearbeiten, bitte warten",
    "it_IT": "In processo, attendere",
    "ko_KR": "진행중, 잠시만 기다려 주세요",
    "pl_PL": "Przetwarzanie, prosimy czekać",
    "pt_PT": "Processing, please wait",
    "es_ES": "Procesando, por favor espera",
    "zh_CN": "处理中，请稍候",
    "zh_TW": "處理中，請稍候"
} );

